export function laserEngravingAccessForUser(user) {
  const metadata = user?.publicMetadata || {};
  const roles = [metadata.role, ...(Array.isArray(metadata.roles) ? metadata.roles : [])]
    .filter(value => typeof value === 'string')
    .map(value => value.trim().toLowerCase().replace(/[\s_]+/g, '-'))
    .map(role => role === 'testgpv' ? 'test-gpv' : role);
  const staff = roles.some(role => ['admin', 'quality-manager', 'production-engineer'].includes(role) || role.startsWith('service'));
  const gpv = roles.some(role => role === 'gpv' || role === 'test-gpv');
  return { allowed: staff || gpv, staff, gpv, isTestUser: roles.includes('test-gpv') };
}
